import React, { useState, useRef, useEffect } from 'react'
import { IoChevronDown } from 'react-icons/io5'
import { DropdownMenu, DropdownItem } from '../MobileSearch/MobileSearch.styles'

interface MobileDropdownProps {
  value: string
  label: string
  onChange: (value: string) => void
  labelPrefix?: string
  options: { value: string; label: string }[]
}

export const MobileDropdown: React.FC<MobileDropdownProps> = ({
  value,
  label,
  onChange,
  labelPrefix = '',
  options,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const handleSelect = (newValue: string) => {
    onChange(newValue)
    setIsOpen(false)
  }

  return (
    <div style={{ position: 'relative' }} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-auto px-2 py-1.5 bg-transparent border-0 inline-flex items-center gap-1 text-sm text-fg cursor-pointer mb-1 hover:opacity-70"
      >
        <div>
          <span className="text-fg-secondary text-sm">{labelPrefix} </span>
          <span className="text-fb-green-900 font-medium underline">
            {label}
          </span>
        </div>
        <IoChevronDown size={20} />
      </button>

      {isOpen && (
        <DropdownMenu style={{ width: 100 }}>
          {options.map((option) => (
            <DropdownItem
              style={{ padding: 10 }}
              key={option.value}
              type="button"
              $isSelected={option.value === value}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </div>
  )
}
